import { render, staticRenderFns } from "./icon-blue-check.vue?vue&type=template&id=56278e2a&"
import script from "./icon-blue-check.vue?vue&type=script&lang=js&"
export * from "./icon-blue-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports